(function () {
  'use strict';

  if (window.__MML_MINIMUM_ORDER_FEE_STABLE_ACTIVE__) return;
  window.__MML_MINIMUM_ORDER_FEE_STABLE_ACTIVE__ = true;

  var settings = window.MinimumOrderFeeSettings || {};

  var ENABLED = settings.enabled === true || settings.enabled === 'true';
  var MINIMUM_AMOUNT = parseFloat(settings.minimumAmount || '85');
  var MINIMUM_CENTS = Math.round(MINIMUM_AMOUNT * 100);

  var FEE_VARIANT_ID = String(settings.feeVariantId || '52192659407131');
  var FEE_PRODUCT_ID = String(settings.feeProductId || '10230186017051');
  var FEE_HANDLE = String(settings.feeProductHandle || 'below-minimum-order-fee').toLowerCase();
  var COLLECTIONS_SHOP_URL = String(settings.collectionsShopUrl || '/collections/all');

  var MESSAGE =
    settings.message ||
    'Minimum order is $85. If your cart is below this amount, a below minimum order fee may be required.';

  var FALLBACK_TITLE = settings.fallbackTitle || 'Below Minimum Order Fee';
  var FALLBACK_SUBTITLE = settings.fallbackSubtitle || 'Required to continue checkout';
  var FALLBACK_PRICE = settings.fallbackPrice || '$38.00';

  if (!ENABLED || isNaN(MINIMUM_AMOUNT) || MINIMUM_AMOUNT <= 0 || !FEE_VARIANT_ID) return;

  var popupOpen = false;
  var popupClosedByCustomer = false;
  var addingFee = false;
  var productCache = null;
  var checkTimer = null;
  var termsAccepted = false;

  function moneyFromCents(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function formatPrice(price) {
    if (price === null || price === undefined || price === '') return FALLBACK_PRICE;

    var numberPrice = Number(price);

    if (isNaN(numberPrice)) return FALLBACK_PRICE;

    if (numberPrice > 999) {
      return moneyFromCents(numberPrice);
    }

    return '$' + numberPrice.toFixed(2);
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  function isFeeItem(item) {
    if (!item) return false;

    var variantId = String(item.variant_id || item.id || '');
    var productId = String(item.product_id || '');
    var handle = String(item.handle || '').toLowerCase();
    var url = String(item.url || '').toLowerCase();
    var title = String(item.title || '').toLowerCase();

    return (
      variantId === FEE_VARIANT_ID ||
      productId === FEE_PRODUCT_ID ||
      handle === FEE_HANDLE ||
      url.indexOf(FEE_HANDLE) !== -1 ||
      title.indexOf('below minimum order fee') !== -1
    );
  }

  function getFeeItem(cart) {
    if (!cart || !cart.items) return null;

    for (var i = 0; i < cart.items.length; i++) {
      if (isFeeItem(cart.items[i])) return cart.items[i];
    }

    return null;
  }

  function cartHasFee(cart) {
    return !!getFeeItem(cart);
  }

  function getSubtotalWithoutFee(cart) {
    var subtotal = 0;

    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) return;
      subtotal += Number(item.final_line_price || item.line_price || 0);
    });

    return subtotal;
  }

  function cartNeedsFee(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return false;

    var subtotalWithoutFee = getSubtotalWithoutFee(cart);

    if (subtotalWithoutFee <= 0) return false;
    if (subtotalWithoutFee >= MINIMUM_CENTS) return false;
    if (cartHasFee(cart)) return false;

    return true;
  }

  function shouldBlockCheckoutForTerms(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return false;
    return !termsAccepted;
  }

  function fetchFeeProduct() {
    if (productCache) return Promise.resolve(productCache);

    return fetch('/products/' + FEE_HANDLE + '.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Fee product fetch failed');
        return response.json();
      })
      .then(function (product) {
        var image = '';

        if (product.featured_image) {
          image = product.featured_image;
        } else if (product.images && product.images.length) {
          image = product.images[0];
        }

        var selectedVariant = null;

        if (product.variants && product.variants.length) {
          for (var i = 0; i < product.variants.length; i++) {
            if (String(product.variants[i].id) === FEE_VARIANT_ID) {
              selectedVariant = product.variants[i];
              break;
            }
          }

          if (!selectedVariant) {
            selectedVariant = product.variants[0];
          }
        }

        productCache = {
          title: product.title || FALLBACK_TITLE,
          subtitle: FALLBACK_SUBTITLE,
          image: image || '',
          price: selectedVariant ? formatPrice(selectedVariant.price) : FALLBACK_PRICE
        };

        return productCache;
      })
      .catch(function () {
        productCache = {
          title: FALLBACK_TITLE,
          subtitle: FALLBACK_SUBTITLE,
          image: '',
          price: FALLBACK_PRICE
        };

        return productCache;
      });
  }

  function resetPopupClosedStateIfCartValid(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      popupClosedByCustomer = false;
      return;
    }

    var subtotalWithoutFee = getSubtotalWithoutFee(cart);

    if (subtotalWithoutFee >= MINIMUM_CENTS || cartHasFee(cart)) {
      popupClosedByCustomer = false;
    }
  }

  function updateTermsCheckbox(cart) {
    var wrapper = document.getElementById('lobster-cart-terms-message');
    var checkbox = document.getElementById('lobster-cart-terms-checkbox');

    if (!wrapper || !checkbox) return;

    if (!cart || !cart.items || cart.items.length === 0) {
      wrapper.style.display = 'none';
      checkbox.checked = false;
      termsAccepted = false;
      return;
    }

    wrapper.style.display = 'block';
    checkbox.checked = termsAccepted;
  }

  function updateMinimumOrderMessage(cart) {
    var messageEls = document.querySelectorAll('#minimum-order-fee-message');

    resetPopupClosedStateIfCartValid(cart);
    updateTermsCheckbox(cart);

    if (!messageEls.length) return;

    messageEls.forEach(function (messageEl) {
      if (!cart || !cart.items || cart.items.length === 0) {
        messageEl.style.display = 'none';
        return;
      }

      var subtotalWithoutFee = getSubtotalWithoutFee(cart);
      var remainingCents = Math.max(0, MINIMUM_CENTS - subtotalWithoutFee);
      var hasFee = cartHasFee(cart);

      if (subtotalWithoutFee >= MINIMUM_CENTS) {
        messageEl.innerHTML = '✅ Minimum order amount reached. No below minimum order fee is required.';
        messageEl.style.display = 'block';
        return;
      }

      if (hasFee) {
        messageEl.innerHTML = '✅ Below minimum order fee added. You can continue to checkout.';
        messageEl.style.display = 'block';
        return;
      }

      var shouldShowCartAddButton = popupClosedByCustomer || !popupOpen;
      var addFeeButtonHtml = '';

      if (shouldShowCartAddButton) {
        addFeeButtonHtml =
          '<br><button type="button" data-minimum-order-fee-add-from-cart style="margin-top:10px;width:100%;min-height:44px;border:0;border-radius:6px;background:#003f50;color:#ffffff;font-size:14px;font-weight:800;cursor:pointer;">Add minimum order fee</button>';
      }

      messageEl.innerHTML =
        MESSAGE +
        '<br><strong>Remaining amount: ' +
        moneyFromCents(remainingCents) +
        '</strong>' +
        addFeeButtonHtml;

      messageEl.style.display = 'block';
    });
  }

  function isCheckoutElement(el) {
    if (!el) return false;

    var href = String(el.getAttribute('href') || '').toLowerCase();
    var name = String(el.getAttribute('name') || '').toLowerCase();
    var text = String(el.textContent || el.value || '').toLowerCase();
    var aria = String(el.getAttribute('aria-label') || '').toLowerCase();

    return (
      href.indexOf('/checkout') !== -1 ||
      name === 'checkout' ||
      text.trim() === 'checkout' ||
      text.indexOf('checkout') !== -1 ||
      aria.indexOf('checkout') !== -1 ||
      el.matches && (
        el.matches('[data-cart-checkout]') ||
        el.matches('[data-checkout]') ||
        el.matches('.cart__checkout-button') ||
        el.matches('.btn--checkout') ||
        el.matches('.checkout-button') ||
        el.matches('#CheckOut') ||
        el.matches('button[name="checkout"]') ||
        el.matches('input[name="checkout"]')
      )
    );
  }

  function getCheckoutElements() {
    return document.querySelectorAll(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-cart-checkout], [data-checkout], .cart__checkout-button, .btn--checkout, .checkout-button, #CheckOut'
    );
  }

  function blockCheckoutButtons(cart) {
    var needsFee = cartNeedsFee(cart);
    var needsTerms = shouldBlockCheckoutForTerms(cart);
    var shouldBlock = needsFee || needsTerms;
    var blockReason = needsFee ? 'fee' : needsTerms ? 'terms' : '';

    getCheckoutElements().forEach(function (button) {
      if (shouldBlock) {
        if (button.tagName === 'A') {
          if (!button.getAttribute('data-minimum-order-original-href')) {
            button.setAttribute('data-minimum-order-original-href', button.getAttribute('href') || '/checkout');
          }

          button.removeAttribute('href');
        }

        if (button.tagName === 'BUTTON' || button.tagName === 'INPUT') {
          button.disabled = true;
        }

        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-minimum-order-checkout-blocked', 'true');
        button.setAttribute('data-minimum-order-block-reason', blockReason);
        button.style.opacity = '0.55';
        button.style.cursor = 'not-allowed';
      } else {
        if (button.tagName === 'A') {
          var originalHref = button.getAttribute('data-minimum-order-original-href');

          if (originalHref) {
            button.setAttribute('href', originalHref);
          }
        }

        if (button.tagName === 'BUTTON' || button.tagName === 'INPUT') {
          button.disabled = false;
        }

        button.removeAttribute('aria-disabled');
        button.removeAttribute('data-minimum-order-checkout-blocked');
        button.removeAttribute('data-minimum-order-block-reason');
        button.style.opacity = '';
        button.style.cursor = '';
      }
    });
  }

  function getVisibleDrawer() {
    var selectors = [
      '#site-cart-sidebar',
      '[data-js-site-cart-sidebar]',
      'cart-drawer',
      '[data-cart-drawer]',
      '.cart-drawer',
      '.cart-drawer__inner',
      '[data-ajax-cart-section]',
      '.site-cart',
      '.cart-sidebar',
      '.drawer',
      '[class*="cart"][class*="drawer"]',
      '[class*="cart"][class*="sidebar"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);

      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        var rect = el.getBoundingClientRect();
        var style = window.getComputedStyle(el);

        if (
          rect.width > 250 &&
          rect.height > 300 &&
          rect.right > window.innerWidth * 0.55 &&
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          Number(style.opacity) !== 0
        ) {
          return el;
        }
      }
    }

    return null;
  }

  function getCartDrawerWidth() {
    var drawer = getVisibleDrawer();

    if (!drawer) return 0;

    var rect = drawer.getBoundingClientRect();

    if (rect.width > 100 && rect.right > window.innerWidth * 0.5) {
      return rect.width;
    }

    return 0;
  }

  function drawerAlreadyHasFee(drawer) {
    if (!drawer) return false;

    if (drawer.querySelector('[data-minimum-order-fee-line="true"]')) {
      return true;
    }

    if (drawer.querySelector('[data-variant-id="' + FEE_VARIANT_ID + '"]')) {
      return true;
    }

    if (drawer.querySelector('[data-cart-item-variant-id="' + FEE_VARIANT_ID + '"]')) {
      return true;
    }

    if (drawer.querySelector('[data-line-item-variant-id="' + FEE_VARIANT_ID + '"]')) {
      return true;
    }

    return false;
  }

  function findFirstCartProductLine(drawer) {
    if (!drawer) return null;

    var candidates = drawer.querySelectorAll('div, li, article, section');

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var text = String(el.textContent || '').toLowerCase();
      var rect = el.getBoundingClientRect();

      if (
        rect.width > 250 &&
        rect.height >= 70 &&
        rect.height <= 190 &&
        text.indexOf('live lobster') !== -1 &&
        text.indexOf('remove') !== -1
      ) {
        return el;
      }
    }

    return null;
  }

  function findOftenBoughtBlock(drawer) {
    if (!drawer) return null;

    var candidates = drawer.querySelectorAll('div, section');

    for (var i = 0; i < candidates.length; i++) {
      var text = String(candidates[i].textContent || '').toLowerCase();
      var rect = candidates[i].getBoundingClientRect();

      if (
        text.indexOf('often bought together') !== -1 &&
        rect.width > 250 &&
        rect.height > 100
      ) {
        return candidates[i];
      }
    }

    return null;
  }

  function getFeeImageFromItemOrProduct(feeItem, product) {
    if (feeItem && feeItem.image) return feeItem.image;
    if (feeItem && feeItem.featured_image) return feeItem.featured_image;
    if (product && product.image) return product.image;
    return '';
  }

  function createInjectedFeeLine(feeItem, product) {
    var title = FALLBACK_TITLE;
    var price = FALLBACK_PRICE;
    var image = '';
    var key = '';

    if (feeItem) {
      title = feeItem.product_title || feeItem.title || FALLBACK_TITLE;
      price = moneyFromCents(feeItem.final_line_price || feeItem.line_price || 0);
      key = feeItem.key || '';
    }

    if (product) {
      title = product.title || title;
      price = product.price || price;
    }

    image = getFeeImageFromItemOrProduct(feeItem, product);

    var row = document.createElement('div');
    row.className = 'minimum-order-fee-injected-line';
    row.setAttribute('data-minimum-order-fee-line', 'true');
    row.setAttribute('data-variant-id', FEE_VARIANT_ID);

    row.style.cssText =
      'display:flex;gap:14px;align-items:flex-start;padding:18px 40px;border-top:1px solid rgba(0,0,0,.12);border-bottom:1px solid rgba(0,0,0,.12);color:#092838;background:transparent;box-sizing:border-box;';

    row.innerHTML =
      '<div style="width:84px;height:84px;flex:0 0 84px;border-radius:8px;overflow:hidden;background:#f1eee6;">' +
        (image
          ? '<img src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '" style="width:100%;height:100%;object-fit:cover;display:block;">'
          : '') +
      '</div>' +
      '<div style="flex:1;min-width:0;padding-top:2px;">' +
        '<div style="font-weight:700;font-size:16px;line-height:1.25;margin-bottom:5px;">' + title + '</div>' +
        '<div style="font-size:13px;line-height:1.35;margin-bottom:7px;color:#5a666d;">Required to continue checkout</div>' +
        '<div style="font-weight:800;font-size:15px;line-height:1;margin-bottom:8px;">' + price + '</div>' +
        '<button type="button" data-minimum-order-fee-remove data-line-key="' + key + '" style="border:0;background:transparent;padding:0;margin:0;text-decoration:underline;font-size:12px;cursor:pointer;color:#6d7478;">Remove</button>' +
      '</div>';

    return row;
  }

  function injectFeeLineIntoDrawer(cart) {
    var drawer = getVisibleDrawer();

    if (!drawer) return;

    if (drawerAlreadyHasFee(drawer)) return;

    var feeItem = getFeeItem(cart);

    if (!feeItem) return;

    fetchFeeProduct().then(function (product) {
      if (drawerAlreadyHasFee(drawer)) return;

      var row = createInjectedFeeLine(feeItem, product);

      var firstProductLine = findFirstCartProductLine(drawer);

      if (firstProductLine && firstProductLine.parentNode) {
        firstProductLine.parentNode.insertBefore(row, firstProductLine.nextSibling);
        return;
      }

      var oftenBoughtBlock = findOftenBoughtBlock(drawer);

      if (oftenBoughtBlock && oftenBoughtBlock.parentNode) {
        oftenBoughtBlock.parentNode.insertBefore(row, oftenBoughtBlock);
        return;
      }

      drawer.insertBefore(row, drawer.firstChild);
    });
  }

  function updateCartCount(cart) {
    if (!cart) return;

    var count = Number(cart.item_count || 0);

    function updateCartTitleText(el) {
      if (!el) return;

      var text = String(el.textContent || '').trim();

      if (/shopping cart\s*\(\d+\)/i.test(text)) {
        el.textContent = text.replace(/\(\d+\)/, '(' + count + ')');
        return;
      }

      if (/^shopping cart$/i.test(text)) {
        el.textContent = 'Shopping Cart (' + count + ')';
      }
    }

    var drawer = getVisibleDrawer();

    if (drawer) {
      var titleSelectors = [
        'h1',
        'h2',
        'h3',
        '.cart-drawer__title',
        '.drawer__title',
        '.cart-title',
        '[class*="cart"][class*="title"]',
        '[class*="drawer"][class*="title"]'
      ];

      titleSelectors.forEach(function (selector) {
        drawer.querySelectorAll(selector).forEach(function (el) {
          var text = String(el.textContent || '').trim().toLowerCase();

          if (text.indexOf('shopping cart') !== -1) {
            updateCartTitleText(el);
          }
        });
      });

      drawer.querySelectorAll('div, span').forEach(function (el) {
        var text = String(el.textContent || '').trim();

        if (
          /^shopping cart\s*\(\d+\)$/i.test(text) ||
          /^shopping cart$/i.test(text)
        ) {
          updateCartTitleText(el);
        }
      });
    }

    document.querySelectorAll('.cart-count-bubble, [data-cart-count], #cart-icon-bubble, [class*="cart-count"]').forEach(function (el) {
      if (el.children.length === 0) {
        el.textContent = count;
      }
    });
  }

  function updateDrawerTotal(cart) {
    var drawer = getVisibleDrawer();

    if (!drawer || !cart) return;

    var totalText = moneyFromCents(cart.total_price);
    var nodes = drawer.querySelectorAll('div, span, strong, p, h2, h3');

    for (var i = 0; i < nodes.length; i++) {
      var text = String(nodes[i].textContent || '').trim();

      if (/^\$\d+(\.\d{2})?$/.test(text)) {
        var parentText = String(nodes[i].parentNode ? nodes[i].parentNode.textContent : '').toLowerCase();

        if (parentText.indexOf('total') !== -1) {
          nodes[i].textContent = totalText;
          return;
        }
      }
    }
  }

  function refreshDrawerAfterFeeAdd(cart) {
    updateMinimumOrderMessage(cart);
    blockCheckoutButtons(cart);
    updateCartCount(cart);
    updateDrawerTotal(cart);
    injectFeeLineIntoDrawer(cart);

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart-drawer:updated', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('ajax-cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('minimum-order-fee:added', { bubbles: true, detail: { cart: cart } }));
  }

  function addStyles() {
    if (document.getElementById('minimum-order-fee-popup-styles')) return;

    var style = document.createElement('style');
    style.id = 'minimum-order-fee-popup-styles';

    style.textContent = `
      .minimum-order-fee-overlay {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: var(--minimum-order-fee-drawer-width, 0px);
        z-index: 2147483646;
        background: rgba(0, 0, 0, 0.58);
        display: none;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
      }

      .minimum-order-fee-overlay.is-active {
        display: flex;
      }

      .minimum-order-fee-popup {
        width: 100%;
        max-width: 560px;
        background: #fffdf7;
        border-radius: 14px;
        box-shadow: 0 28px 80px rgba(0, 0, 0, 0.42);
        position: relative;
        padding: 48px 36px 28px;
        color: #092838;
        font-family: inherit;
        box-sizing: border-box;
        animation: minimumOrderFeePopupIn 0.22s ease-out;
      }

      @keyframes minimumOrderFeePopupIn {
        from {
          opacity: 0;
          transform: translateY(12px) scale(0.98);
        }

        to {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      }

      .minimum-order-fee-close {
        position: absolute;
        top: 17px;
        right: 20px;
        width: 34px;
        height: 34px;
        border: 0;
        background: transparent;
        color: #092838;
        font-size: 38px;
        line-height: 28px;
        font-weight: 300;
        cursor: pointer;
        padding: 0;
      }

      .minimum-order-fee-title {
        margin: 0 auto 16px;
        max-width: 430px;
        text-align: center;
        color: #092838;
        font-size: 28px;
        line-height: 1.32;
        font-weight: 800;
        letter-spacing: -0.02em;
      }

      .minimum-order-fee-description {
        margin: 0 auto 24px;
        max-width: 440px;
        text-align: center;
        color: #092838;
        font-size: 20px;
        line-height: 1.45;
        font-weight: 400;
      }

      .minimum-order-fee-product-card {
        background: #f1eee6;
        border-radius: 9px;
        padding: 22px 22px 20px;
        text-align: center;
        margin-bottom: 14px;
        box-sizing: border-box;
      }

      .minimum-order-fee-product-image {
        display: block;
        width: 230px;
        height: 180px;
        margin: 0 auto 18px;
        border-radius: 7px;
        object-fit: cover;
        background: #e8e1d6;
      }

      .minimum-order-fee-product-image.is-hidden {
        display: none;
      }

      .minimum-order-fee-product-title {
        margin: 0 0 6px;
        color: #092838;
        font-size: 22px;
        line-height: 1.25;
        font-weight: 800;
      }

      .minimum-order-fee-product-subtitle {
        margin: 0 0 12px;
        color: #092838;
        font-size: 18px;
        line-height: 1.3;
        font-weight: 400;
      }

      .minimum-order-fee-product-price {
        margin: 0;
        color: #092838;
        font-size: 22px;
        line-height: 1;
        font-weight: 900;
      }

      .minimum-order-fee-button {
        width: 100%;
        min-height: 64px;
        border: 0;
        border-radius: 8px;
        cursor: pointer;
        font-family: inherit;
        font-size: 20px;
        line-height: 1.2;
        font-weight: 800;
        text-align: center;
      }

      .minimum-order-fee-button:disabled {
        cursor: not-allowed;
        opacity: 0.82;
      }

      .minimum-order-fee-add {
        background: #003f50;
        color: #ffffff;
        margin-bottom: 12px;
      }

      .minimum-order-fee-more {
        background: #bd4329;
        color: #ffffff;
      }

      .minimum-order-fee-spinner {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        border: 4px solid rgba(255, 255, 255, 0.42);
        border-top-color: #ffffff;
        display: inline-block;
        vertical-align: middle;
        margin-left: 16px;
        animation: minimumOrderFeeSpin 0.8s linear infinite;
      }

      @keyframes minimumOrderFeeSpin {
        to {
          transform: rotate(360deg);
        }
      }

      .minimum-order-fee-error {
        display: none;
        margin: 12px 0 0;
        padding: 11px 13px;
        background: #fff0f0;
        border: 1px solid #bd4329;
        color: #9b2414;
        border-radius: 7px;
        text-align: center;
        font-size: 14px;
        font-weight: 700;
      }

      body.minimum-order-fee-no-scroll {
        overflow: hidden;
      }

      [data-minimum-order-checkout-blocked="true"] {
        opacity: 0.55 !important;
        cursor: not-allowed !important;
      }

      @media screen and (max-width: 900px) {
        .minimum-order-fee-overlay {
          right: 0;
          z-index: 2147483647;
        }
      }

      @media screen and (max-width: 640px) {
        .minimum-order-fee-overlay {
          padding: 14px;
        }

        .minimum-order-fee-popup {
          max-width: 100%;
          padding: 42px 20px 22px;
          border-radius: 12px;
        }

        .minimum-order-fee-title {
          font-size: 22px;
        }

        .minimum-order-fee-description {
          font-size: 16px;
        }

        .minimum-order-fee-product-image {
          width: 190px;
          height: 145px;
        }

        .minimum-order-fee-button {
          min-height: 56px;
          font-size: 17px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function createPopup() {
    if (document.getElementById('minimum-order-fee-overlay')) return;

    addStyles();

    var overlay = document.createElement('div');
    overlay.id = 'minimum-order-fee-overlay';
    overlay.className = 'minimum-order-fee-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    overlay.innerHTML = `
      <div class="minimum-order-fee-popup" role="dialog" aria-modal="true" aria-labelledby="minimum-order-fee-popup-title">
        <button type="button" class="minimum-order-fee-close" id="minimum-order-fee-close" aria-label="Close">×</button>

        <h2 class="minimum-order-fee-title" id="minimum-order-fee-popup-title">
          Your order does not meet the minimum order value of $${MINIMUM_AMOUNT}
        </h2>

        <p class="minimum-order-fee-description">
          We’ll add an order fee to your cart, or you can select more products.
        </p>

        <div class="minimum-order-fee-product-card">
          <img class="minimum-order-fee-product-image is-hidden" id="minimum-order-fee-product-image" src="" alt="">

          <h3 class="minimum-order-fee-product-title" id="minimum-order-fee-product-title">
            ${FALLBACK_TITLE}
          </h3>

          <p class="minimum-order-fee-product-subtitle" id="minimum-order-fee-product-subtitle">
            ${FALLBACK_SUBTITLE}
          </p>

          <p class="minimum-order-fee-product-price" id="minimum-order-fee-product-price">
            ${FALLBACK_PRICE}
          </p>
        </div>

        <button type="button" class="minimum-order-fee-button minimum-order-fee-add" id="minimum-order-fee-add">
          Add order fee
        </button>

        <button type="button" class="minimum-order-fee-button minimum-order-fee-more" id="minimum-order-fee-more">
          I’ll add more products
        </button>

        <div class="minimum-order-fee-error" id="minimum-order-fee-error">
          Order fee could not be added. Please try again.
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    document.getElementById('minimum-order-fee-close').addEventListener('click', function () {
      closePopup(true);
    });

    document.getElementById('minimum-order-fee-more').addEventListener('click', function () {
      window.location.href = COLLECTIONS_SHOP_URL;
    });

    document.getElementById('minimum-order-fee-add').addEventListener('click', addFeeProduct);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closePopup(true);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popupOpen) closePopup(true);
    });
  }

  function updatePopupPosition() {
    var overlay = document.getElementById('minimum-order-fee-overlay');
    if (!overlay) return;

    var drawerWidth = getCartDrawerWidth();

    if (window.innerWidth <= 900) {
      drawerWidth = 0;
    }

    overlay.style.setProperty('--minimum-order-fee-drawer-width', drawerWidth + 'px');
  }

  function updatePopupProduct(product) {
    var imageEl = document.getElementById('minimum-order-fee-product-image');
    var titleEl = document.getElementById('minimum-order-fee-product-title');
    var subtitleEl = document.getElementById('minimum-order-fee-product-subtitle');
    var priceEl = document.getElementById('minimum-order-fee-product-price');

    if (titleEl) titleEl.textContent = product.title || FALLBACK_TITLE;
    if (subtitleEl) subtitleEl.textContent = product.subtitle || FALLBACK_SUBTITLE;
    if (priceEl) priceEl.textContent = product.price || FALLBACK_PRICE;

    if (imageEl) {
      if (product.image) {
        imageEl.src = product.image;
        imageEl.alt = product.title || FALLBACK_TITLE;
        imageEl.classList.remove('is-hidden');
      } else {
        imageEl.classList.add('is-hidden');
      }
    }
  }

  function openPopup() {
    createPopup();
    updatePopupPosition();

    var overlay = document.getElementById('minimum-order-fee-overlay');
    var errorEl = document.getElementById('minimum-order-fee-error');

    if (!overlay) return;

    if (errorEl) errorEl.style.display = 'none';

    fetchFeeProduct().then(function (product) {
      updatePopupProduct(product);
    });

    popupOpen = true;
    document.body.classList.add('minimum-order-fee-no-scroll');
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');

    fetchCart()
      .then(function (cart) {
        updateMinimumOrderMessage(cart);
      })
      .catch(function () {});
  }

  function closePopup(closedByCustomer) {
    var overlay = document.getElementById('minimum-order-fee-overlay');

    popupOpen = false;

    if (closedByCustomer) {
      popupClosedByCustomer = true;
    }

    document.body.classList.remove('minimum-order-fee-no-scroll');

    if (overlay) {
      overlay.classList.remove('is-active');
      overlay.setAttribute('aria-hidden', 'true');
    }

    fetchCart()
      .then(function (cart) {
        updateMinimumOrderMessage(cart);
        blockCheckoutButtons(cart);
        updateCartCount(cart);
      })
      .catch(function () {});
  }

  function setAddButtonLoading(isLoading) {
    var button = document.getElementById('minimum-order-fee-add');

    if (!button) return;

    button.disabled = isLoading;

    if (isLoading) {
      button.innerHTML = 'Adding to cart... <span class="minimum-order-fee-spinner"></span>';
    } else {
      button.innerHTML = 'Add order fee';
    }
  }

  function setCartAddButtonsLoading(isLoading) {
    document.querySelectorAll('[data-minimum-order-fee-add-from-cart]').forEach(function (button) {
      button.disabled = isLoading;

      if (isLoading) {
        button.textContent = 'Adding fee...';
        button.style.opacity = '0.82';
        button.style.cursor = 'not-allowed';
      } else {
        button.textContent = 'Add minimum order fee';
        button.style.opacity = '';
        button.style.cursor = 'pointer';
      }
    });
  }

  function showError(message) {
    var errorEl = document.getElementById('minimum-order-fee-error');

    if (!errorEl) return;

    errorEl.textContent = message || 'Order fee could not be added. Please try again.';
    errorEl.style.display = 'block';
  }

  function addFeeProduct() {
    if (addingFee) return;

    addingFee = true;
    setAddButtonLoading(true);
    setCartAddButtonsLoading(true);

    fetchCart()
      .then(function (cart) {
        if (cartHasFee(cart)) {
          return cart;
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(FEE_VARIANT_ID),
            quantity: 1,
            properties: {
              _minimum_order_fee: 'true'
            }
          })
        }).then(function (response) {
          if (!response.ok) {
            return response.text().then(function (text) {
              throw new Error(text || 'Fee product add failed');
            });
          }

          return response.json();
        });
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        popupClosedByCustomer = false;
        updateMinimumOrderMessage(cart);
        blockCheckoutButtons(cart);
        closePopup(false);
        refreshDrawerAfterFeeAdd(cart);
      })
      .catch(function (error) {
        console.warn('[Minimum Order Fee Popup]', error);
        showError('Order fee could not be added. Please try again.');
      })
      .finally(function () {
        addingFee = false;
        setAddButtonLoading(false);
        setCartAddButtonsLoading(false);
      });
  }

  function checkCartAndShowPopup(forceOpen) {
    clearTimeout(checkTimer);

    checkTimer = setTimeout(function () {
      fetchCart()
        .then(function (cart) {
          updateMinimumOrderMessage(cart);
          blockCheckoutButtons(cart);
          updateCartCount(cart);

          if (cartNeedsFee(cart)) {
            if (forceOpen || !popupOpen) {
              openPopup();
            }
          } else {
            closePopup(false);
          }
        })
        .catch(function (error) {
          console.warn('[Minimum Order Fee Popup] Cart check failed:', error);
        });
    }, 250);
  }

  function isCartAddUrl(url) {
    return String(url || '').indexOf('/cart/add') !== -1;
  }

  function isCartMutationUrl(url) {
    url = String(url || '');

    return (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1
    );
  }

  function guardCheckoutClick(event) {
    var target = event.target && event.target.closest
      ? event.target.closest('a, button, input[type="submit"], input[type="button"]')
      : null;

    if (!target) return;
    if (!isCheckoutElement(target)) return;

    fetchCart()
      .then(function (cart) {
        updateMinimumOrderMessage(cart);
        blockCheckoutButtons(cart);
        updateCartCount(cart);

        if (cartNeedsFee(cart)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          openPopup();
          return;
        }

        if (shouldBlockCheckoutForTerms(cart)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          updateTermsCheckbox(cart);
        }
      })
      .catch(function () {});
  }

  function removeFeeLineByKey(lineKey) {
    if (!lineKey) return;

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Remove failed');
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-minimum-order-fee-line="true"]').forEach(function (el) {
          el.remove();
        });

        updateMinimumOrderMessage(cart);
        blockCheckoutButtons(cart);
        updateCartCount(cart);
        updateDrawerTotal(cart);

        if (cartNeedsFee(cart)) {
          openPopup();
        }
      })
      .catch(function () {});
  }

  function patchFetch() {
    if (window.__MML_MINIMUM_ORDER_FETCH_PATCHED_STABLE__) return;
    window.__MML_MINIMUM_ORDER_FETCH_PATCHED_STABLE__ = true;

    var originalFetch = window.fetch;

    window.fetch = function (resource, options) {
      var url = typeof resource === 'string'
        ? resource
        : resource && resource.url
          ? resource.url
          : '';

      var isAddToCart = isCartAddUrl(url);
      var isMutation = isCartMutationUrl(url);

      var promise = originalFetch.apply(this, arguments);

      if (isMutation) {
        promise
          .then(function (response) {
            if (response && response.ok) {
              setTimeout(function () {
                fetchCart()
                  .then(function (cart) {
                    updateMinimumOrderMessage(cart);
                    blockCheckoutButtons(cart);
                    updateCartCount(cart);

                    if (isAddToCart && cartNeedsFee(cart)) {
                      openPopup();
                    }
                  })
                  .catch(function () {});
              }, isAddToCart ? 500 : 700);
            }
          })
          .catch(function () {});
      }

      return promise;
    };
  }

  function patchXHR() {
    if (window.__MML_MINIMUM_ORDER_XHR_PATCHED_STABLE__) return;
    window.__MML_MINIMUM_ORDER_XHR_PATCHED_STABLE__ = true;

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__minimumOrderFeeUrl = url || '';
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__minimumOrderFeeUrl || '';

      var isAddToCart = isCartAddUrl(url);
      var isMutation = isCartMutationUrl(url);

      if (isMutation) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            setTimeout(function () {
              fetchCart()
                .then(function (cart) {
                  updateMinimumOrderMessage(cart);
                  blockCheckoutButtons(cart);
                  updateCartCount(cart);

                  if (isAddToCart && cartNeedsFee(cart)) {
                    openPopup();
                  }
                })
                .catch(function () {});
            }, isAddToCart ? 500 : 700);
          }
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  function watchClicks() {
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('button, a, input[type="submit"], input[type="button"], input[type="checkbox"]')
        : null;

      if (!target) return;

      if (target.matches && target.matches('#lobster-cart-terms-checkbox')) {
        termsAccepted = target.checked;

        fetchCart()
          .then(function (cart) {
            updateMinimumOrderMessage(cart);
            blockCheckoutButtons(cart);
            updateCartCount(cart);
          })
          .catch(function () {});

        return;
      }

      if (target.matches && target.matches('[data-minimum-order-fee-add-from-cart]')) {
        event.preventDefault();
        event.stopPropagation();
        addFeeProduct();
        return;
      }

      if (target.matches && target.matches('[data-minimum-order-fee-remove]')) {
        event.preventDefault();
        event.stopPropagation();
        removeFeeLineByKey(target.getAttribute('data-line-key'));
        return;
      }

      if (isCheckoutElement(target)) {
        if (target.getAttribute('data-minimum-order-checkout-blocked') === 'true') {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (target.getAttribute('data-minimum-order-block-reason') === 'fee') {
            openPopup();
          }

          return;
        }

        guardCheckoutClick(event);
        return;
      }

      var text = String(target.textContent || target.value || '').toLowerCase();
      var href = String(target.getAttribute('href') || '').toLowerCase();
      var name = String(target.getAttribute('name') || '').toLowerCase();

      var isAddClick =
        name === 'add' ||
        text.indexOf('add to cart') !== -1 ||
        href.indexOf('/cart/add') !== -1;

      var isCartChangeClick =
        href.indexOf('/cart/change') !== -1 ||
        href.indexOf('/cart/update') !== -1 ||
        text.indexOf('remove') !== -1 ||
        text.indexOf('delete') !== -1 ||
        text.trim() === '+' ||
        text.trim() === '-';

      if (isAddClick) {
        setTimeout(function () {
          checkCartAndShowPopup(true);
        }, 900);
      }

      if (isCartChangeClick) {
        setTimeout(function () {
          fetchCart()
            .then(function (cart) {
              updateMinimumOrderMessage(cart);
              blockCheckoutButtons(cart);
              updateCartCount(cart);
            })
            .catch(function () {});
        }, 700);
      }
    }, true);
  }

  function watchForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!form || !form.matches) return;

      var action = String(form.getAttribute('action') || '').toLowerCase();

      if (
        form.matches('form[action="/cart/add"]') ||
        action.indexOf('/cart/add') !== -1
      ) {
        setTimeout(function () {
          checkCartAndShowPopup(true);
        }, 900);

        return;
      }

      var submitter = event.submitter || document.activeElement;
      var isCheckoutSubmitter = submitter && isCheckoutElement(submitter);

      if (!isCheckoutSubmitter) return;

      fetchCart()
        .then(function (cart) {
          updateMinimumOrderMessage(cart);
          blockCheckoutButtons(cart);
          updateCartCount(cart);

          if (cartNeedsFee(cart)) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            openPopup();
            return;
          }

          if (shouldBlockCheckoutForTerms(cart)) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            updateTermsCheckbox(cart);
          }
        })
        .catch(function () {});
    }, true);
  }

  function watchQuantityChanges() {
    document.addEventListener('change', function (event) {
      var target = event.target;

      if (!target || !target.matches) return;

      if (target.matches('#lobster-cart-terms-checkbox')) {
        termsAccepted = target.checked;

        fetchCart()
          .then(function (cart) {
            updateMinimumOrderMessage(cart);
            blockCheckoutButtons(cart);
            updateCartCount(cart);
          })
          .catch(function () {});

        return;
      }

      if (
        target.matches('input[name="updates[]"]') ||
        target.matches('input[data-quantity-input]') ||
        target.matches('.quantity__input') ||
        target.matches('input[type="number"]')
      ) {
        setTimeout(function () {
          fetchCart()
            .then(function (cart) {
              updateMinimumOrderMessage(cart);
              blockCheckoutButtons(cart);
              updateCartCount(cart);
            })
            .catch(function () {});
        }, 700);
      }
    }, true);
  }

  function watchThemeEvents() {
    [
      'cart:updated',
      'cart:change',
      'cart-drawer:open',
      'cart-drawer:updated',
      'CartDrawer:open',
      'on:cart:change',
      'theme:cart:update',
      'cart-items:change',
      'ajax-cart:open',
      'ajax-cart:updated',
      'minimum-order-fee:cart-html-updated',
      'lobster:updated'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        setTimeout(function () {
          updatePopupPosition();

          fetchCart()
            .then(function (cart) {
              updateMinimumOrderMessage(cart);
              blockCheckoutButtons(cart);
              updateCartCount(cart);
            })
            .catch(function () {});
        }, 450);
      });
    });
  }

  function watchResize() {
    window.addEventListener('resize', updatePopupPosition);
  }

  function init() {
    createPopup();
    patchFetch();
    patchXHR();
    watchClicks();
    watchForms();
    watchQuantityChanges();
    watchThemeEvents();
    watchResize();

    fetchCart()
      .then(function (cart) {
        updateMinimumOrderMessage(cart);
        blockCheckoutButtons(cart);
        updateCartCount(cart);
      })
      .catch(function () {});

    document.addEventListener('shopify:section:load', function () {
      fetchCart()
        .then(function (cart) {
          updateMinimumOrderMessage(cart);
          blockCheckoutButtons(cart);
          updateCartCount(cart);
        })
        .catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();